module.exports = new __parcel__URL__("water-temp.2d74f9b3.png").toString();